var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49933 19.4962C8.40079 19.4967 8.30314 19.4774 8.21213 19.4397C8.12112 19.4019 8.03857 19.3463 7.96933 19.2762C7.82888 19.1356 7.75 18.945 7.75 18.7462C7.75 18.5475 7.82888 18.3568 7.96933 18.2162L14.1893 11.9962L7.96933 5.77621C7.82888 5.63559 7.75 5.44497 7.75 5.24622C7.75 5.04747 7.82888 4.85684 7.96933 4.71622C8.11289 4.57752 8.30472 4.5 8.50433 4.5C8.70395 4.5 8.89577 4.57752 9.03934 4.71622L15.7893 11.4662C15.9298 11.6068 16.0087 11.7975 16.0087 11.9962C16.0087 12.195 15.9298 12.3856 15.7893 12.5262L9.03934 19.2762C8.96857 19.3471 8.88434 19.4031 8.7916 19.4409C8.69885 19.4786 8.59947 19.4975 8.49933 19.4962Z",
    fill: "#969696"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/Chevron-Right.86a6629bbf53554a915c10771edf3d6f.svg";
export { ForwardRef as ReactComponent };